export default __webpack_public_path__ + "static/media/bathea.0a33659a.jpg";